import React from 'react';

export default function Hero() {
  return (
    <>
      <div className="flex h-full w-full" name="about-me">
        <div className="h-full w-screen">
          <img
            className="w-full"
            src="/assets/grumpy.webp"
            alt="hero of mira kinebuchi"
          />
        </div>
      </div>
    </>
  );
}
